export enum ReasonComplaintsEnum {
  LOW_APPROVE = "LOW_APPROVE",
  NOT_ENOUGH_APPROVE = "NOT_ENOUGH_APPROVE"
}